module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"highlights":"Highlights","dependants":"Dependants","parentService":"Parent service","parentServiceWithId":"Parent service with {id}","goToMainApplicantCase":"Go to main applicant case","goToSWVCase":"Go to SWV case","goToECCase":"Go to EC case"}}}')
  delete Component.options._Ctor
}
